import Education from './Education';

export default Education;



// WEBPACK FOOTER //
// ./src/Education/index.js